var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIkZastepujace = function SvgIkZastepujace(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22.494,
    height: 19.604
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 8782"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 8747"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3120",
    d: "m8.201 11.93 3.361 3.361 3.361-3.361",
    fill: "none",
    stroke: "#118cc6",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 8749"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3120",
    d: "m8.2 4.93 3.361 3.361 3.361-3.361",
    fill: "none",
    stroke: "#118cc6",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 8752"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3424",
    d: "M7.233 18.6H4.191A3.063 3.063 0 0 1 1 15.684V3.916A3.063 3.063 0 0 1 4.191 1h3.042",
    fill: "none",
    stroke: "#118cc6",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 8750"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3424",
    d: "M15.261 18.6h3.042a3.063 3.063 0 0 0 3.191-2.913V3.916A3.063 3.063 0 0 0 18.303 1h-3.042",
    fill: "none",
    stroke: "#118cc6",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })))));
};
export default SvgIkZastepujace;